export enum MediaType {
  Video = 'video',
  Picture = 'picture',
}
